import { render, staticRenderFns } from "./programEditor.vue?vue&type=template&id=5fe021aa&"
import script from "./programEditor.vue?vue&type=script&lang=js&"
export * from "./programEditor.vue?vue&type=script&lang=js&"
import style0 from "./programEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports